import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import OfferActions, { offerActionTypes } from '@Actions/offerActions';
import OfferService from '../services/offerServices';

/**
 *
 * @param {*} action
 */
function* _createOffer(action) {
  try {
    yield put(OfferActions.createOfferLoading(true));
    const { payload } = action;
    const newOffer = yield OfferService.createOffer(payload);
    if (action.callback) {
      action.callback();
    }
    yield put(OfferActions.createOfferLoading(false));
    if (newOffer.success) {
      yield put(TrackerActions.trackAction(offerActionTypes.CREATE_OFFER.SUCCESS, {
        request: action?.payload,
        response: newOffer,
      }));
      notification.open({
        type: 'success',
        message: 'Offer created successfully.',
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'error',
        message: newOffer.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(OfferActions.createOfferLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.CREATE_OFFER.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* createOffer() {
  yield takeLatest(offerActionTypes.CREATE_OFFER.REQUEST, _createOffer);
}
/**
 *
 * @param {*} action
 */
function* _deleteOffer(action) {
  try {
    yield put(OfferActions.deleteOfferLoading(true));
    const deletedSku = yield OfferService.deleteOffer(action.offerId);
    yield put(OfferActions.deleteOfferLoading(false));
    notification.open({
      type: 'success',
      message: 'Offer deleted successfully.',
      duration: 4,
      placement: 'top',
    });
  } catch (error) {
    yield put(OfferActions.deleteOfferLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.DELETE_OFFER.ERROR, error));
  }
}
/**
 *
 */
function* deleteOffer() {
  yield takeLatest(offerActionTypes.DELETE_OFFER.REQUEST, _deleteOffer);
}
/**
 *
 * @param {*} action
 */
function* _getSkuOffers(action) {
  try {
    yield put(OfferActions.getOffersLoading(true));
    const skuOffers = yield OfferService.getOffers(action?.tenantProductId, action?.tenantSellerId);
    yield put(OfferActions.getOffersSuccess(skuOffers));
    yield put(OfferActions.getOffersLoading(false));
  } catch (error) {
    yield put(OfferActions.getOffersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.GET_OFFERS.ERROR, error));
  }
}
/**
 *
 */
function* getSkuOffers() {
  yield takeLatest(offerActionTypes.GET_OFFERS.REQUEST, _getSkuOffers);
}
/**
 *
 * @param {*} action
 */
function* _updateOffer(action) {
  try {
    yield put(OfferActions.updateOfferLoading(true));
    const updatedOffer = yield OfferService.updateOffer(action.payload);
    yield put(OfferActions.getOffers(action?.payload?.sku_id));
    yield put(OfferActions.updateOfferLoading(false));
    yield put(TrackerActions.trackAction(offerActionTypes.UPDATE_OFFER.SUCCESS, {
      request: action?.payload,
      response: updatedOffer,
    }));
    notification.open({
      type: 'success',
      message: 'Offer updated successfully.',
      duration: 4,
      placement: 'top',
    });
    if (action.callback) {
      action.callback();
    }
    if (action.toggleShowEditModal) action.toggleShowEditModal();
  } catch (error) {
    yield put(OfferActions.updateOfferLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.UPDATE_OFFER.ERROR, error));
  }
}
/**
 *
 */
function* updateOffer() {
  yield takeLatest(offerActionTypes.UPDATE_OFFER.REQUEST, _updateOffer);
}

/**
 *
 * @param {*} action
 */
function* _getOffersBySku(action) {
  try {
    yield put(OfferActions.getOffersBySkuLoading(true));
    const skuOffers = yield OfferService.getOffersBySku(action.sellerId, action.page);
    yield put(OfferActions.getOffersBySkuSuccess(skuOffers));
    yield put(OfferActions.getOffersBySkuLoading(false));
  } catch (error) {
    yield put(OfferActions.getOffersBySkuLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.GET_OFFER_BY_SKU.ERROR, error));
  }
}
/**
 *
 */
function* getOffersBySku() {
  yield takeLatest(offerActionTypes.GET_OFFER_BY_SKU.REQUEST, _getOffersBySku);
}

/**
 *
 * @param {*} action
 */
function* _getSellingPrices(action) {
  try {
    yield put(OfferActions.getSellingPricesLoading(true));
    const {
      sellingPriceId, orgId, tenantId, skuId, quantity, page, limit,
    } = action;
    const sellingPrice = yield OfferService.getSellingPrices(sellingPriceId, orgId, tenantId, skuId, quantity, page, limit);
    yield put(OfferActions.getSellingPricesSuccess(sellingPrice));
    yield put(OfferActions.getSellingPricesLoading(false));
  } catch (error) {
    yield put(OfferActions.getSellingPricesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.GET_SELLING_PRICE.ERROR, error));
  }
}
/**
 *
 */
function* getSellingPrices() {
  yield takeLatest(offerActionTypes.GET_SELLING_PRICE.REQUEST, _getSellingPrices);
}

/**
 * @param action
 */
function* _createSellingPrice(action) {
  try {
    yield put(OfferActions.createSellingPriceLoading(true));
    const createSP = yield OfferService.createSellingPrice(action.payload);
    yield put(OfferActions.createSellingPriceLoading(false));
    if (createSP.success) {
      notification.open({
        type: 'success',
        message: 'Contracted Price created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback()) action.callback();
    } else {
      notification.open({
        type: 'error',
        message: createSP?.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(OfferActions.createSellingPriceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.CREATE_SELLING_PRICE.ERROR, error));
  }
}

/**
 *
 */
function* createSellingPrice() {
  yield takeLatest(offerActionTypes.CREATE_SELLING_PRICE.REQUEST, _createSellingPrice);
}

/**
 * @param action
 */
function* _updateSellingPrice(action) {
  try {
    yield put(OfferActions.updateSellingPriceLoading(true));
    const updatedSellingPrice = yield OfferService.updateSellingPrice(action.payload);
    yield put(OfferActions.updateSellingPriceLoading(false));
    if (updatedSellingPrice.success) {
      yield put(TrackerActions.trackAction(offerActionTypes.UPDATE_SELLING_PRICE.SUCCESS, updatedSellingPrice.data));
      notification.open({
        type: 'success',
        message: 'Contracted Price updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) action.callback();
    } else {
      notification.open({
        type: 'error',
        message: updatedSellingPrice?.message,
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(OfferActions.updateSellingPriceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.UPDATE_SELLING_PRICE.ERROR, error));
  }
}

/**
 *
 */
function* updateSellingPrice() {
  yield takeLatest(offerActionTypes.UPDATE_SELLING_PRICE.REQUEST, _updateSellingPrice);
}

/**
 * @param action
 */
function* _getTenantSkuOffer(action) {
  try {
    yield put(OfferActions.getOfferByTenantSkuLoading(true));
    const skuOffers = yield OfferService.getOffers(action?.tenantProductId, action?.tenantSellerId, action?.tenantProductIds);
    yield put(OfferActions.getOfferByTenantSkuSuccess(skuOffers));
    if (action.callback) {
      if (action?.tenantProductIds) {
        // action.callback(skuOffers?.offers, skuOffers?.offers);
        action.callback(skuOffers?.offer_by_tenant_product_ids, skuOffers?.offers);
      } else {
        action.callback(skuOffers?.offers?.[0], skuOffers?.offers);
      }
    }
    yield put(OfferActions.getOfferByTenantSkuLoading(false));
  } catch (error) {
    yield put(OfferActions.getOfferByTenantSkuLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.GET_OFFER_BY_TENANT_SKU.ERROR, error));
  }
}

/**
 *
 */
function* getTenantSkuOffer() {
  yield takeLatest(offerActionTypes.GET_OFFER_BY_TENANT_SKU.REQUEST, _getTenantSkuOffer);
}

function* _getAllSellerOffers(action) {
  try {
    yield put(OfferActions.getAllSellerOffersLoading(true));
    const sellerOffers = yield OfferService.getAllSellerOffers(action?.productSkuId, action?.tenantIds, action?.page, action?.limit, action?.sellerId);
    yield put(OfferActions.getAllSellerOffersSuccess(sellerOffers));
    if (action.callback) {
      action.callback(sellerOffers?.offers?.sellers?.[0]);
    }
    yield put(OfferActions.getAllSellerOffersLoading(false));
  } catch (error) {
    yield put(OfferActions.getAllSellerOffersLoading(false));
    notification.open({

      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.GET_ALL_SELLER_OFFERS.ERROR, error));
  }
}

function* getAllSellerOffers() {
  yield takeLatest(offerActionTypes.GET_ALL_SELLER_OFFERS.REQUEST, _getAllSellerOffers);
}

// Archive Offer Price

function* _archiveOfferPrice(action) {
  try {
    yield put(OfferActions.archiveOfferPriceLoading(true));
    const archiveOfferPriceRes = yield OfferService.archiveOfferPrice(action.payload);
    yield put(OfferActions.archiveOfferPriceLoading(false));
    if (archiveOfferPriceRes.success) {
      notification.open({
        type: 'success',
        message: 'Vendor price deleted successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) action.callback();
    } else {
      notification.open({
        type: 'error',
        message: archiveOfferPriceRes?.message || 'Something went wrong',
        duration: 4,
        placement: 'top',
      });
    }
  } catch (error) {
    yield put(OfferActions.archiveOfferPriceLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(offerActionTypes.ARCHIVE_OFFER_PRICE.ERROR, error));
  }
}

function* archiveOfferPrice() {
  yield takeLatest(offerActionTypes.ARCHIVE_OFFER_PRICE.REQUEST, _archiveOfferPrice);
}

export default function* offerSaga() {
  yield all([createOffer(), deleteOffer(), getSkuOffers(), updateOffer(), getOffersBySku(), archiveOfferPrice(),
  getSellingPrices(), createSellingPrice(), updateSellingPrice(), getTenantSkuOffer(), getAllSellerOffers()]);
}
